<ng-container *ngLet="loading$ | async as loading">
    <ui-grid [data]="data$ | async"
             [loading]="loading$ | async"
             class="ui-users-page-grid">
        <ui-grid-header *ngLet="isMenuExpandable$ | async as isMenuExpandable"
                        [search]="true">
            <ui-header-button type="inline">
                <ng-template>
                    <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                                   (reset)="resetFilter()"></ui-grid-reset>
                </ng-template>
            </ui-header-button>

            <ui-header-button *ngIf="!isViewOnly || isWindowsAuthenticationEnabled"
                              type="main">
                <ng-template>
                    <ui-action-expander #expander
                                        *ngIf="isWindowsAuthenticationEnabled; else windowsAuthenticationDisabled"
                                        [disabled]="!isMenuExpandable"
                                        [matTooltip]="isMenuExpandable ? null : ('authorize_no_permissions' | translate)"
                                        [tooltipOpen]="'grid_action_add' | translate"
                                        [tooltipClose]="'modal_action_close' | translate"
                                        data-cy="user-add">
                        <button *ngIf="!isViewOnly"
                                [uiAuthorizeAll]="['Users.Create', 'Roles.View']"
                                [matTooltip]="'users_grid_action_import' | translate"
                                [uiClickTrack]="'Action: Import Users from AD'"
                                (click)="openImportModal()"
                                mat-mini-fab
                                color="primary"
                                data-cy="user-add-ad"
                                type="button">
                            <mat-icon>group_add</mat-icon>
                        </button>
                        <button *ngIf="!isViewOnly"
                                [uiAuthorizeAllDisable]="['Users.Create', 'Roles.View']"
                                [matTooltip]="'users_grid_action_add' | translate"
                                [uiAutofocus]
                                [refocus]="expander.isActionExpanded$ | async"
                                [uiClickTrack]="'Action: Add User'"
                                (click)="openModal(UserType.User)"
                                mat-mini-fab
                                color="primary"
                                data-cy="user-add-standard"
                                type="button">
                            <mat-icon>person_add</mat-icon>
                        </button>
                        <button *ngIf="isWindowsAuthenticationEnabled"
                                [uiClickTrack]="'Action: Grid: Check Roles For AD'"
                                [matTooltip]="'users_grid_action_check_permissions' | translate"
                                [uiAuthorizeAllDisable]="['Units.View', 'Users.View', 'Roles.View']"
                                (click)="checkPermissions()"
                                mat-mini-fab
                                color="primary"
                                data-cy="user-check-permissions-for-ad"
                                type="button">
                            <mat-icon>security</mat-icon>
                        </button>
                    </ui-action-expander>

                    <ng-template #windowsAuthenticationDisabled>
                        <button [uiAuthorizeAllDisable]="['Users.Create', 'Roles.View']"
                                [matTooltip]="'users_grid_action_add' | translate"
                                [uiAutofocus]
                                [uiClickTrack]="'Action: Add User'"
                                (click)="openModal(UserType.User)"
                                mat-mini-fab
                                color="primary"
                                data-cy="user-add-standard"
                                type="button">
                            <mat-icon>add</mat-icon>
                        </button>
                    </ng-template>
                </ng-template>
            </ui-header-button>
            <ui-header-button type="action">
                <ng-template>
                    <button [disabled]="!allowDelete || isViewOnly"
                            [uiAuthorize]="'Users.Delete'"
                            [matTooltip]="'users_grid_action_remove' | translate"
                            (click)="removeItems()"
                            mat-icon-button
                            color="warn"
                            data-cy="user-delete-global"
                            type="button">
                        <mat-icon svgIcon="uipath:Delete20px">
                        </mat-icon>
                    </button>
                </ng-template>
            </ui-header-button>
        </ui-grid-header>
        <ui-grid-column [visible]="false"
                        [title]="'users_grid_type' | translate"
                        [resizeable]="false"
                        property="type"
                        data-cy="user-grid-type">
            <ui-grid-dropdown-filter [items]="userTypes"
                                     [value]="defaultUserType"></ui-grid-dropdown-filter>

        </ui-grid-column>
        <ui-grid-column [sortable]="true"
                        [searchable]="true"
                        [primary]="true"
                        [title]="'users_grid_username' | translate"
                        [width]="'15%'"
                        sort="asc"
                        property="userName">
            <ng-template let-entry="data">
                <mat-icon *ngIf="UserIconMap[entry.type].svgIcon; else userMatIcon"
                          [svgIcon]="UserIconMap[entry.type].svgIcon">
                </mat-icon>
                <ng-template #userMatIcon>
                    <mat-icon>{{ UserIconMap[entry.type].matIcon }}</mat-icon>
                </ng-template>
                <span [matTooltip]="entry.userName">
                    {{ entry.userName }}
                </span>
            </ng-template>
        </ui-grid-column>
        <ui-grid-column [sortable]="true"
                        [searchable]="true"
                        [title]="'users_grid_name' | translate"
                        [width]="'8%'"
                        property="name">
        </ui-grid-column>
        <ui-grid-column [title]="'users_grid_surname' | translate"
                        [sortable]="true"
                        [searchable]="true"
                        [width]="'8%'"
                        property="surname">
        </ui-grid-column>
        <ui-grid-column [sortable]="true"
                        [searchable]="true"
                        [title]="'users_grid_email' | translate"
                        width="10%"
                        property="emailAddress">
        </ui-grid-column>
        <ui-grid-column [sortable]="true"
                        [title]="'users_grid_last_login' | translate"
                        [width]="'8%'"
                        property="lastLoginDate">
            <ng-template let-index="index"
                         let-entry="data">
                <ui-dateformat *ngIf="entry.type !== UserType.Robot"
                               [date]="entry.lastLoginDate"
                               contentType="relative"></ui-dateformat>
            </ng-template>
        </ui-grid-column>
        <ui-grid-column [sortable]="false"
                        [title]="'users_grid_roles' | translate"
                        [width]="'18%'"
                        property="rolesList">
        </ui-grid-column>

        <ui-grid-column [sortable]="true"
                        [title]="'users_grid_status' | translate"
                        [width]="'6%'"
                        property="isActive">
            <ui-grid-dropdown-filter [items]="statusList">
            </ui-grid-dropdown-filter>
            <ng-template let-entry="data">
                <ng-container [ngSwitch]="entry.isActive">
                    <span *ngSwitchCase="true"
                          translate>
                        UserStatus_Active
                    </span>
                    <span *ngSwitchCase="false"
                          translate>
                        UserStatus_Inactive
                    </span>
                </ng-container>
            </ng-template>
        </ui-grid-column>

        <ng-container *uiModernContext>
            <ui-grid-column [sortable]="true"
                            [title]="'users_grid_webaccess' | translate"
                            [width]="'7%'"
                            property="mayHaveUserSession">
                <ui-grid-dropdown-filter [items]="webAccess">
                </ui-grid-dropdown-filter>
                <ng-template let-entry="data">
                    <ng-container [ngSwitch]="entry.mayHaveUserSession">
                        <span *ngSwitchCase="true"
                              translate>
                            UserWebAccess_Enabled
                        </span>
                        <span *ngSwitchCase="false"
                              translate>
                            UserWebAccess_Disabled
                        </span>
                    </ng-container>
                </ng-template>
            </ui-grid-column>

            <ui-grid-column [sortable]="true"
                            [title]="'users_grid_robotAccess' | translate"
                            [width]="'9%'"
                            property="mayHaveRobotSession">
                <ui-grid-dropdown-filter [items]="robotAccess">
                </ui-grid-dropdown-filter>
                <ng-template let-entry="data">
                    <span translate>
                        {{robotAccessKey(entry)}}
                    </span>
                </ng-template>
            </ui-grid-column>
        </ng-container>

        <ui-grid-row-action>
            <ng-template let-index="index"
                         let-entry="data">
                <button [uiAuthorizeAnyDisable]="['Users.View', 'Users.Edit', 'Users.Delete']"
                        [matMenuTriggerFor]="menu"
                        [matTooltip]="'global_more_actions_tooltip' | translate"
                        data-cy="grid-action-menu"
                        mat-icon-button
                        type="button">
                    <mat-icon svgIcon="uipath:More"></mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button [uiAuthorizeAnyDisable]="editUserPermissions"
                            [uiClickTrack]="'Action: Grid: Edit'"
                            (click)="openModal(entry.type, entry)"
                            mat-menu-item
                            data-cy="user-edit">
                        <mat-icon svgIcon="uipath:Edit"></mat-icon>
                        <span>{{ 'users_grid_action_edit' | translate }}</span>
                    </button>
                    <a *ngIf="entry.type === UserType.User ||
                              entry.type === UserType.DirectoryUser"
                       [routerLink]="['/profile', entry.id]"
                       [uiAuthorizeDisable]="'Users.View'"
                       mat-menu-item
                       data-cy="user-view-profile">
                        <mat-icon>person</mat-icon>
                        <span translate>users_grid_action_view_profile</span>
                    </a>
                    <button *ngIf="entry.type !== UserType.Robot"
                            [uiClickTrack]="'Action: Grid: Check Permissions'"
                            [uiAuthorizeAllDisable]="['Units.View', 'Users.View', 'Roles.View']"
                            (click)="checkPermissions(entry)"
                            mat-menu-item
                            data-cy="user-check-permissions"
                            type="button">
                        <mat-icon>security</mat-icon>
                        <span>{{ 'users_grid_action_check_permissions' | translate }}</span>
                    </button>
                    <button *ngIf="!isViewOnly"
                            [disableIf]="entry.isActive || !userCanBeDeactivated(entry)"
                            [class.loading]="loading"
                            [uiAuthorizeDisable]="'Users.Edit'"
                            [uiClickTrack]="'Action: Grid: Activate'"
                            (click)="setActive(entry, true)"
                            mat-menu-item
                            data-cy="user-activate-account"
                            type="button">
                        <mat-icon svgIcon="uipath:activateUser"></mat-icon>
                        <span translate>users_grid_action_activate</span>
                    </button>
                    <button *ngIf="!isViewOnly"
                            [disableIf]="!entry.isActive || !userCanBeDeactivated(entry)"
                            [class.loading]="loading"
                            [uiAuthorizeDisable]="'Users.Edit'"
                            [uiClickTrack]="'Action: Grid: Deactivate'"
                            (click)="setActive(entry, false)"
                            mat-menu-item
                            data-cy="user-deactivate-account"
                            type="button">
                        <mat-icon svgIcon="uipath:deactivateUser"></mat-icon>
                        <span translate>users_grid_action_deactivate</span>
                    </button>
                    <button *ngIf="!isViewOnly"
                            [disableIf]="!userCanBeDeleted(entry)"
                            [uiAuthorizeDisable]="'Users.Delete'"
                            [uiClickTrack]="'Action: Grid: Remove'"
                            (click)="removeItems([entry])"
                            mat-menu-item
                            data-cy="user-delete"
                            type="button">
                        <mat-icon svgIcon="uipath:Delete"></mat-icon>
                        <span translate>users_grid_action_remove</span>
                    </button>
                </mat-menu>
            </ng-template>
        </ui-grid-row-action>
        <ui-grid-footer [length]="total$ | async"
                        [pageSize]="pageSize"
                        [pageSizes]="pageSizes">
        </ui-grid-footer>
    </ui-grid>
</ng-container>
